/* eslint max-classes-per-file: 0 */

import {
  PermissionsGroup as Data,
  PermissionsGroupCollection as Collection,
} from '@/typings/api/PermissionsGroup'
import { PermissionsGroupsApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'


const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class PermissionsGroupsTransformerParams extends TransformerParams {
}

export class PermissionsGroupsAdapter extends Adapter<Api> {
  public readonly api = new Api();

  public readonly transformerParams = new PermissionsGroupsTransformerParams();
}
